/**
 * @param notificationButton icon button to pin to
 * @returns right position and top for button and panel
 */
export function getNotificationPosition(notificationButton: HTMLElement | null) {
  if (!notificationButton || !document.getElementsByClassName('dp-portal-frame')[0]) {
    return {
      right: 10,
      iconTop: 0,
      iconBottom: 10,
    };
  }

  const iconElRect = notificationButton.getBoundingClientRect();
  const portalRect = document.getElementsByClassName('dp-portal-frame')[0].getBoundingClientRect();
  const portalWidth = portalRect.width;
  const right = portalWidth - iconElRect.x - iconElRect.width;
  const iconTop = iconElRect.y - portalRect.y;
  const iconBottom = Math.max(iconTop + iconElRect.height, 10); // during scroll, leave it at top

  return {
    right,
    iconTop,
    iconBottom,
  };
}

export const NotificationUtils = {
  getNotificationPosition,
};
